import { cur } from './units';
import * as XLSX from 'xlsx';
import { I18N } from './i18n';
import { getCrew, jobTimes } from './crew';
import { download } from './exporters';

const h2 = (m) => Math.round((m / 60) * 100) / 100;
export const monthOf = (ms) => { const d = new Date(ms); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; };

export function timesheetRows(projects, month) {
  const crew = getCrew(), by = {};
  projects.forEach((p) => (p.reports || []).forEach((r) => {
    const job = r.job || {}, ev = job.ev || {}, ts = ev.start || ev.depart || ev.arrive;
    if (!ts || monthOf(ts) !== month) return;
    const ids = (job.staff || []).filter((id) => crew.staff.some((s) => s.id === id));
    (ids.length ? ids : ['_none']).forEach((id) => { (by[id] ||= []).push({ p, r, job, ev, ts }); });
  }));
  return { crew, by };
}

export const tsHead = (t) => [t.hyDate, t.tzProject, t.tzReport, t.wlCustomer, t.wlOrder, t.wl_depart, t.wl_arrive, t.wl_start, t.wl_end, t.wl_back, `${t.wlPauses} (h)`, `${t.wlWork} (h)`, `${t.wlTravel} (h)`, `${t.wlSum} (h)`, `${cur()}/h`, `${cur()}`];

// per staff member: rows + totals (staff without assignment -> '_none')
export function staffSheets(projects, month, t) {
  const { crew, by } = timesheetRows(projects, month);
  const clk = (ms) => (ms ? new Date(ms).toLocaleTimeString(t.locale, { hour: '2-digit', minute: '2-digit' }) : '');
  return Object.keys(by).sort((a, b) => (a === '_none') - (b === '_none')).map((id) => {
    const s = crew.staff.find((x) => x.id === id) || { id, name: t.tzNoStaff, role: '', rate: '' }, rate = Number(s.rate) || 0;
    const list = by[id].sort((a, b) => a.ts - b.ts);
    let W = 0, T = 0;
    const rows = list.map(({ p, r, job, ev, ts }) => {
      const tm = jobTimes(job), tot = h2(tm.work + tm.travel);
      W += tm.work; T += tm.travel;
      return [new Date(ts).toLocaleDateString(t.locale), p.title || '', r.title || '', job.customer || '', job.order || '', clk(ev.depart), clk(ev.arrive), clk(ev.start), clk(ev.end), clk(ev.back), h2(tm.pause), h2(tm.work), h2(tm.travel), tot, rate || '', rate ? Math.round(tot * rate * 100) / 100 : ''];
    });
    const tot = h2(W + T);
    return { id, s, rate, rows, work: h2(W), travel: h2(T), tot, cost: rate ? Math.round(tot * rate * 100) / 100 : '', days: new Set(list.map((x) => new Date(x.ts).toDateString())).size };
  });
}

export function exportTimesheet(projects, month, lang, stem = 'Stundenzettel') {
  const t = I18N[lang] || I18N.de, sheets = staffSheets(projects, month, t);
  if (!sheets.length) return 0;
  const wb = XLSX.utils.book_new(), over = [[t.tzStaff, t.wlRole, t.tzDays, `${t.wlWork} (h)`, `${t.wlTravel} (h)`, `${t.wlSum} (h)`, `${cur()}/h`, `${cur()}`]];
  const used = new Set();
  sheets.forEach(({ s, rate, rows, work, travel, tot, cost, days }) => {
    const ws = XLSX.utils.aoa_to_sheet([[`${t.tzTitle} ${month} – ${s.name}${s.role ? ` (${s.role})` : ''}`], [], tsHead(t), ...rows, [], [t.wlSum, '', '', '', '', '', '', '', '', '', '', work, travel, tot, rate || '', cost], [], [`${t.tzSign}: ______________________`]]);
    ws['!cols'] = [11, 18, 18, 18, 12, 8, 8, 8, 8, 8, 9, 9, 9, 9, 7, 10].map((w) => ({ wch: w }));
    let name = s.name.replace(/[\\/?*[\]:]/g, '').slice(0, 28) || 'MA';
    while (used.has(name)) name = `${name.slice(0, 26)}_${used.size}`;
    used.add(name);
    XLSX.utils.book_append_sheet(wb, ws, name);
    over.push([s.name, s.role || '', days, work, travel, tot, rate || '', cost]);
  });
  const ov = XLSX.utils.aoa_to_sheet([[`${t.tzTitle} ${month}`], [], ...over]);
  ov['!cols'] = [22, 16, 8, 10, 10, 10, 8, 10].map((w) => ({ wch: w }));
  XLSX.utils.book_append_sheet(wb, ov, t.tzOverview.slice(0, 31));
  wb.SheetNames.unshift(wb.SheetNames.pop());
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  download(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${stem}_${month}.xlsx`);
  return sheets.length;
}
